import React, { Component } from 'react';
import InboxCard from './InboxCard';
import Dotdotdot from 'react-dotdotdot';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { appBasePath } from '../../constants/staticData';

export default class InboxComponents extends Component {
  renderInboxMessages() {
    const chatRooms = cloneDeep(this.props.commonReducer.chatRooms);
    const sortedChatRooms = this.props.sortBy == 'old' ? chatRooms.reverse() : chatRooms;
    return sortedChatRooms.map((chatRoom, key) => {
      const chatRoomAllData = this.props.commonReducer.chatMessages[chatRoom.id];
      const message = (chatRoomAllData && chatRoomAllData.messages && chatRoomAllData.messages.length > 0) ? chatRoomAllData.messages[chatRoomAllData.messages.length - 1] : (chatRoom.messages && chatRoom.messages.length > 0) ? chatRoom.messages[chatRoom.messages.length - 1] : null;
      let messageDate = '';
      let messageTime = '';
      if (message && message.createdAt) {
        messageDate = moment(message.createdAt).format("MMM DD, YYYY");
        messageTime = moment(message.createdAt).format ("hh:mm A");
      }
      return (
        <div key={key}>
            <div className={(chatRoom.userbookingrequest && chatRoom.userbookingrequest.services && chatRoom.userbookingrequest.services.name) ? ('inbox-card ' + chatRoom.userbookingrequest.services.name.toLowerCase()) : 'inbox-card'} onClick={(e) => {e.preventDefault(); this.props.router.push(`${appBasePath}/job/${chatRoom.jobrequestId}?current_tab=messages`)}}>
                <div className="inbox-sender">
                    <label>{chatRoom.customer.name}</label>
                    <span>{chatRoom.userbookingrequest && chatRoom.userbookingrequest.requestid ? chatRoom.userbookingrequest.requestid : ''}</span>
                </div>
                <div className="inbox-icon" onClick={(e) => {e.preventDefault(); this.props.router.push(`${appBasePath}/job/${chatRoom.jobrequestId}?current_tab=messages`)}}>
                    <i className="mdi mdi-share" />
                </div>
                <div className="inbox-text">
                    {message && <Dotdotdot clamp={2}>
                        {message.msg}
                    </Dotdotdot>}
                </div>
                <div className="inbox-right">
                    <div className="inbox-time">
                        {messageDate && <span>{messageDate}</span>}
                        {messageTime && <span>{messageTime} </span>}
                    </div>
                    <div className="inbox-unread-icon" />
                </div>
            </div>
        </div>
      );
    })
  }
  render() {
    const inboxView  = this.renderInboxMessages();
    return (
      <div>
        <div className="inbox-list">
          {inboxView}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Inbox/InboxComponents.jsx